const cookieConsentOpts = {
    cookie: {
        ___domain: 'digital.library.unt.edu',
    },
    content: {
        message: 'The Digital Library employs cookies to assess our features and to improve your experience.',
        dismiss: 'Got it!',
        link: 'Learn more.',
        href: '/about/digital-library/policies/',
    },
    theme: 'aubrey',
    type: 'info',
    position: 'bottom',
};

export default cookieConsentOpts;
